import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-balance-sheet-create',
  templateUrl: './balance-sheet-create.component.html',
  styleUrls: ['./balance-sheet-create.component.scss']
})
export class BalanceSheetCreateComponent implements OnInit {

  constructor(private formBuilder: FormBuilder, private http: HttpClient, private ActivatedRoute: ActivatedRoute, private router: Router, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  message = null;
  class = null;
  action = null;
  submitted = false;
  public Form: FormGroup;

  ngOnInit() {
    
    this.action = 'Submit';
    this.ActivatedRoute.params.subscribe(params => {
      let id = params['id'];
    
      // console.log(`${id}`);
      this.http.get<any>(this.api_endpoint+'/balanceSheetbyid/' + `${id}`).subscribe(
        data => {
          // console.log(data.data);
          if(data.data != null){
            this.action = 'Update';
            this.Form.patchValue({
              _id: data.data._id,
              title: data.data.title,
              link: data.data.link,
            });
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    });


    this.Form = this.formBuilder.group({
      title: ['', Validators.required],
      link: ['', Validators.required],
      _id: [''],
    })
  }

  get f() { return this.Form.controls; }

  onFormSubmit() {
    
    this.submitted = true;

    if (this.Form.invalid) {
      return;
    }

    if(this.action == 'Submit'){
    
    var data = {
      "title" : this.Form.value.title,
      "link" : this.Form.value.link,
      "admin" : sessionStorage.getItem('adminName'),
    };
    // console.log(data);
    this.http.post<any>(this.api_endpoint+'/balanceSheet', data).subscribe(
      res => {
        console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          window.scrollTo(document.documentElement.clientWidth, 0);
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        } 
        this.router.navigateByUrl('/adminhkbkcms/balance-sheet/list-page');
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
    });
  }else{
    var data1 = {
      "title" : this.Form.value.title,
      "link" : this.Form.value.link,
      "admin" : sessionStorage.getItem('adminName'),
      "_id" : this.Form.value._id,
    };
      // console.log(data1);     
      this.http.put<any>(this.api_endpoint+'/balanceSheet/', data1).subscribe(
      res => {
        console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          window.scrollTo(document.documentElement.clientWidth, 0);
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        } 
        this.router.navigateByUrl('/adminhkbkcms/balance-sheet/list-page');
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
  }
  }

}
